import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './Pages/Home';
import Header from './Components/header/Header';
import Footer from './Components/footer/Footer';
import ScrollToTop from './Components/ScrollToTop';
import ContactUs from './Pages/ContactUs';

function App() {
  return (
    <>
    <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
